import { render } from "./ImgMenuSet.vue?vue&type=template&id=0846072a&scoped=true"
import script from "./ImgMenuSet.vue?vue&type=script&lang=js"
export * from "./ImgMenuSet.vue?vue&type=script&lang=js"

import "./ImgMenuSet.vue?vue&type=style&index=0&id=0846072a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0846072a"]])

export default __exports__